import Cookie from "js-cookie";
import { LEGACY_COOKIE_ONE_TRUST } from "../../Chrome/BrowseContext/constants.js";
const ONETRUST_TO_TRANSCEND_MAPPING = {
  C0001: "Essential",
  C0002: "Analytics",
  C0003: "Functional",
  C0004: "SaleOfInfo"
};
const createConsentHandler = (handler) => {
  return (event) => {
    var _a;
    if (event instanceof CustomEvent && event.type === "consent-change" && ((_a = event.detail) == null ? void 0 : _a.consent)) {
      handler(event);
    } else {
      console.warn("Invalid consent change event received");
    }
  };
};
const syncOTConsent = (consent) => {
  let otPreferences = Cookie.get(LEGACY_COOKIE_ONE_TRUST);
  const otGroups = ["C0001:1"];
  let updatedOtGrpsString = "";
  Object.keys(ONETRUST_TO_TRANSCEND_MAPPING).filter(
    (key) => key !== "C0001"
  ).forEach((key) => {
    const purposeStatus = consent == null ? void 0 : consent.purposes[ONETRUST_TO_TRANSCEND_MAPPING[key]];
    if (typeof purposeStatus !== "undefined") {
      otGroups.push(key + ":" + (purposeStatus !== false ? "1" : "0"));
    }
  });
  updatedOtGrpsString = otGroups.join(",");
  if (typeof otPreferences !== "undefined" && otPreferences != null) {
    const grpsRegex = /groups=([^&]+)/;
    const grpsMatch = otPreferences.match(grpsRegex);
    if (grpsMatch) {
      const groupsValue = grpsMatch[1];
      otPreferences = otPreferences.replace(
        groupsValue,
        updatedOtGrpsString
      );
      Cookie.set(LEGACY_COOKIE_ONE_TRUST, otPreferences);
    }
  } else {
    Cookie.set(
      LEGACY_COOKIE_ONE_TRUST,
      "&groups=".concat(updatedOtGrpsString)
    );
  }
};
const getOTConsent = (classCode, site) => {
  const defaultConsent = site.toLowerCase().startsWith("us") ? true : false;
  if (typeof classCode === "undefined") {
    return false;
  }
  const otPreferences = Cookie.get(LEGACY_COOKIE_ONE_TRUST);
  const classOptInStatus = classCode + ":1";
  if (typeof otPreferences === "undefined") {
    return defaultConsent;
  }
  return otPreferences.indexOf(classOptInStatus) > -1;
};
const restoreConsent = async (event, site) => {
  const otPreferences = Cookie.get(LEGACY_COOKIE_ONE_TRUST);
  if (typeof otPreferences === "undefined" || otPreferences == null) {
    if (typeof self.airgap !== "undefined" && typeof self.airgap.getConsent() !== "undefined") {
      syncOTConsent(window.airgap.getConsent());
    }
  }
  const consent = {
    Analytics: getOTConsent("C0002", site),
    Functional: getOTConsent("C0003", site),
    SaleOfInfo: getOTConsent("C0004", site),
    Advertising: true
  };
  if (typeof window.airgap !== "undefined") {
    await window.airgap.setConsent(event, consent);
  }
};
export {
  createConsentHandler,
  restoreConsent,
  syncOTConsent
};
